import React from "react";
import PropTypes from "prop-types";

function StudioToolbarAction({ action }) {
  const {
    id,
    label,
    ariaLabel = label,
    title = label,
    disabled = false,
    active = false,
    onClick = null,
  } = action;

  return (
    <button
      type="button"
      className={[
        "studio-framework-toolbar__action",
        active
          ? "studio-framework-toolbar__action--active"
          : "",
      ]
        .filter(Boolean)
        .join(" ")}
      aria-label={ariaLabel}
      aria-pressed={active || undefined}
      title={title}
      disabled={disabled}
      onClick={() => onClick?.(id)}
    >
      {label}
    </button>
  );
}

StudioToolbarAction.propTypes = {
  action: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.node.isRequired,
    ariaLabel: PropTypes.string,
    title: PropTypes.string,
    disabled: PropTypes.bool,
    active: PropTypes.bool,
    onClick: PropTypes.func,
  }).isRequired,
};

export default function StudioToolbar({
  groups = [],
  trailing = null,
  ariaLabel = "Studio toolbar",
}) {
  const visibleGroups = groups.filter(
    (group) =>
      group &&
      group.hidden !== true &&
      Array.isArray(group.actions) &&
      group.actions.length > 0
  );

  if (visibleGroups.length === 0 && !trailing) {
    return null;
  }

  return (
    <div
      className="studio-framework-toolbar"
      role="toolbar"
      aria-label={ariaLabel}
    >
      <div className="studio-framework-toolbar__groups">
        {visibleGroups.map((group) => (
          <div
            key={group.id}
            className="studio-framework-toolbar__group"
            role="group"
            aria-label={group.label || group.id}
          >
            {group.actions
              .filter((action) => action.hidden !== true)
              .map((action) => (
                <StudioToolbarAction
                  key={action.id}
                  action={action}
                />
              ))}
          </div>
        ))}
      </div>

      {trailing && (
        <div className="studio-framework-toolbar__trailing">
          {trailing}
        </div>
      )}
    </div>
  );
}

const actionShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  ariaLabel: PropTypes.string,
  title: PropTypes.string,
  disabled: PropTypes.bool,
  active: PropTypes.bool,
  hidden: PropTypes.bool,
  onClick: PropTypes.func,
});

StudioToolbar.propTypes = {
  groups: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string,
      hidden: PropTypes.bool,
      actions: PropTypes.arrayOf(actionShape).isRequired,
    })
  ),
  trailing: PropTypes.node,
  ariaLabel: PropTypes.string,
};
